var angular = require( "angular" );

angular.module( "flowersApp" )
    .directive( "fancybox", require( "./FancyBoxDirective" ) )
    .directive( "dropZone", require( "./DropzoneDirective" ) )
    .directive( "backButton", require( "./BackButtonDirective" ) )
    .directive( "scrollToFirstInvalid", require( "./ScrollToFirstInvalidInputDirective" ) )
    .directive( "numbersOnly", require( "./NumbersOnlyDirective" ) )
    .directive( "lazyLoad", require( "./LazyLoadDirective" ) )
    .directive( "sticky", require( "./StickyDirective" ) );